import { render, staticRenderFns } from "./AprovacaoSolicitacaoDetalhes.vue?vue&type=template&id=2ac1e60c&"
import script from "./AprovacaoSolicitacaoDetalhes.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacaoDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports